import { useCallback } from "react";
import { logUsage } from "owa-analytics";
import { isMailboxSharedOrDelegate } from "owa-account-shared-mailbox-utils";
import type { CategoryWellProps } from "owa-categories/lib/components/CategoryWell";
import { getStore, type TableQueryType } from "owa-mail-list-store";
import { getMailboxInfo } from "owa-mail-mailboxinfo";

// List identities stay local: they can contain folder IDs, category names and search queries.
const reportedListIds = new Set<string>();
const listContexts: Record<TableQueryType, string> = {
    [0]: "Folder",
    [1]: "Search",
    [2]: "Group",
    [3]: "GroupFolder",
    [4]: "CopilotResults",
    [5]: "MyOutlook",
};

export default function useLogMissingCategory(tableViewId: string): NonNullable<CategoryWellProps["onMissingCategory"]> {
    return useCallback<NonNullable<CategoryWellProps["onMissingCategory"]>>((mailboxInfo, diagnostics) => {
        // Only log once per tableViewId
        if (reportedListIds.has(tableViewId)) {
            return;
        }
        reportedListIds.add(tableViewId);
        
        const tableView = getStore().tableViews.get(tableViewId);
        const listMailboxInfo = tableView ? getMailboxInfo(tableView) : undefined;
        const isShared = isMailboxSharedOrDelegate(mailboxInfo);
        logUsage("MailListCategoryMissingFromMasterList", mailboxInfo, {
            ListContext: listMailboxInfo?.type === "UnifiedInbox"
                ? "UnifiedInbox"
                : tableView
                    ? listContexts[tableView.tableQuery.type]
                    : "Unknown",
            MailboxType: mailboxInfo.type,
            MailboxRank: mailboxInfo.mailboxRank ?? "Unknown",
            SharedAccessMode: isShared
                ? mailboxInfo.type === "SharedMailbox" || mailboxInfo.mailboxRank === "Resource"
                    ? "SharedResource"
                    : "SharedAccount"
                : "NotShared",
            ...diagnostics,
        });
    }, [tableViewId]);
}
